// extracted by css-extract-rspack-plugin
export default {"triggerButton":"jkFwh","listItem":"MsvaV","divider":"WkMov"};